module.exports = __webpack_public_path__ + "static/media/IMG_4659.78f40ee9.JPG";